export default __webpack_public_path__ + "static/media/how-it-works_image3.7c2b001f.png";